import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { mapHireStatusToText } from '../../../utils';
import { HireStatus } from '../../../enums';
import { Icon } from '../../../../../../base/components/Icon';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { responsesActions } from '../../../redux/slices/responsesSlice';

import './styles.scss';

interface Props {
    className?: string;
}

export const StatusSelect = ({ className = '' }: Props) => {
    const dispatch = useAppDispatch();
    const { hireStatus } = useAppSelector((state) => state.employerResponses.filters);

    const handleChange = (event: SelectChangeEvent<HireStatus>) => {
        dispatch(responsesActions.setFiltersHireStatus(event.target.value as HireStatus));
    };

    const closeHandler = () => {
        setTimeout(() => {
            const element = document.activeElement as HTMLElement;
            element?.blur();
        }, 0);
    };

    const clearFilter = () => {
        dispatch(responsesActions.setFiltersHireStatus(HireStatus.All));
    };

    return (
        <div className='responses-filters-select-relative-wrap'>
            <Select
                className={`responses-filters-select ${className}`}
                value={hireStatus}
                onChange={handleChange}
                onClose={closeHandler}
                variant='standard'
                disableUnderline
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                    classes: { paper: 'responses-filters-select__dropdown', list: 'responses-filters-select__list' },
                }}
                IconComponent={(props) => <Icon icon='chevron-down-regular' size='14px' {...props} />}
                renderValue={(value: HireStatus) => {
                    if (value === HireStatus.All) {
                        return mapHireStatusToText(value);
                    }

                    return (
                        <div className='responses-filters-select__render-value' title={mapHireStatusToText(value)}>
                            {mapHireStatusToText(value)}
                        </div>
                    );
                }}
            >
                <MenuItem
                    className='responses-filters-select__item responses-filters-select__item--hidden'
                    value={HireStatus.All}
                >
                    {mapHireStatusToText(HireStatus.All)}
                </MenuItem>
                <MenuItem className='responses-filters-select__item' value={HireStatus.NotInvited}>
                    {mapHireStatusToText(HireStatus.NotInvited)}
                </MenuItem>
                <MenuItem className='responses-filters-select__item' value={HireStatus.Invited}>
                    {mapHireStatusToText(HireStatus.Invited)}
                </MenuItem>
                <MenuItem className='responses-filters-select__item' value={HireStatus.InProgress}>
                    {mapHireStatusToText(HireStatus.InProgress)}
                </MenuItem>
                <MenuItem className='responses-filters-select__item' value={HireStatus.Hired}>
                    {mapHireStatusToText(HireStatus.Hired)}
                </MenuItem>
            </Select>
            {hireStatus !== HireStatus.All && (
                <div onClick={clearFilter} className='responses-filters-select__clear-filter-button'>
                    <Icon icon='xmark-regular' size='14px' />
                </div>
            )}
        </div>
    );
};
